<div role="menu" [ngClass]="{ 'disabled':disabled }">
    <div *ngFor="let value of values">
        <label (click)="!disabled && valueToggled($event, value)">
            <span [ngClass]="{'icon-checked': getSelected(value), 'icon-check': !getSelected(value)}" aria-checked="true" role="menuitemcheckbox"></span> {{ value|capitalize }}</label>
    </div>
</div>